module.exports = __webpack_public_path__ + "static/media/treasure-hunt.ecca7f57.png";